<template>
  <div class="login-card">
    <!-- Header -->
    <div class="login-header">
      <div class="login-logo">
        <span style="font-size: 32px; line-height: 1;">🥛</span>
      </div>
      <h1 class="login-title">חלוקת מוצרי חלב</h1>
      <p class="login-subtitle">ברוך הבא — התחבר לחשבונך</p>
    </div>

    <!-- Form -->
    <div class="login-body">
      <v-form @submit.prevent="login" ref="form">

        <div class="field-wrapper">
          <label class="field-label">שם משתמש</label>
          <v-text-field v-model="username" type="text" :rules="[v => !!v || 'שדה חובה']" placeholder="הזן שם משתמש"
            outlined dense class="styled-input" prepend-inner-icon="mdi-account-outline" dir="ltr"
            required></v-text-field>
        </div>

        <div class="field-wrapper">
          <label class="field-label">סיסמה</label>
          <v-text-field v-model="password" :type="showPassword ? 'text' : 'password'" :rules="[v => !!v || 'שדה חובה']"
            placeholder="הזן סיסמה" outlined dense class="styled-input" prepend-inner-icon="mdi-lock-outline"
            :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
            @click:append="showPassword = !showPassword" dir="ltr" required></v-text-field>
        </div>

        <!-- Login Button -->
        <v-btn block depressed class="login-btn" :loading="progressShow" @click="login" type="submit">
          <v-icon left size="18">mdi-login-variant</v-icon>
          כניסה למערכת
        </v-btn>

      </v-form>
    </div>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </div>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {
  components: { SnackBar },
  data: () => ({
    username: "",
    password: "",
    showPassword: false,
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
  }),
  methods: {
    async login() {
      if (this.$refs.form.validate()) {
        this.progressShow = true;
        let MyJSON = JSON.stringify({ username: this.username, password: this.password });
        let api = process.env.VUE_APP_BASE_URL + "/auth/login";
        try {
          const response = await fetch(api, ApiServices.requestOptions("POST", MyJSON, ""));
          this.progressShow = false;
          const jsonObject = await response.json();
          if (response.status === 400) {
            this.showSnackBar("שגיאת התחברות: " + jsonObject.message, "red");
          } else if (response.status === 429) {
            this.showSnackBar("יותר מדי נסיונות כניסה", "red");
          } else if (response.status === 200) {
            this.showSnackBar("התחברת בהצלחה!", "green");
            localStorage.setItem('token', jsonObject.token);
            this.$router.replace({ name: "home" });
          }
        } catch (error) {
          this.progressShow = false;
          this.showSnackBar("Error Login: " + error, "red");
        }
      }
    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true;
    },
  },
  watch: {
    $route() {
      document.title = 'כניסה | משמחי לב';
    },
  },
  mounted() {
    document.title = 'כניסה | משמחי לב';
  },
}
</script>

<style scoped>
.login-card {
  width: 100%;
  max-width: 420px;
  background: white;
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(14, 129, 196, 0.15), 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  direction: rtl;
  position: relative;
  z-index: 1;
}

/* Header */
.login-header {
  background: linear-gradient(135deg, #0e81c4 0%, #0a6ba3 100%);
  padding: 36px 32px 32px;
  text-align: center;
}

.login-logo {
  width: 70px;
  height: 70px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  backdrop-filter: blur(10px);
}

.login-title {
  color: white;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 6px 0;
}

.login-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  margin: 0;
}

/* Body */
.login-body {
  padding: 32px;
}

.field-wrapper {
  margin-bottom: 8px;
}

.field-label {
  display: block;
  font-size: 0.82rem;
  font-weight: 500;
  color: #4b5563;
  margin-bottom: 6px;
}

.styled-input>>>.v-input__slot {
  background: #f8fafc !important;
  border-radius: 12px !important;
  min-height: 46px !important;
  transition: all 0.2s ease;
}

.styled-input>>>.v-input__slot:hover {
  background: #f1f5f9 !important;
}

.styled-input>>>.v-input__slot fieldset {
  border-color: #e2e8f0 !important;
  transition: border-color 0.2s;
}

.styled-input>>>.v-input--is-focused .v-input__slot {
  background: #ffffff !important;
}

.styled-input>>>.v-input--is-focused .v-input__slot fieldset {
  border-color: #0e81c4 !important;
  border-width: 2px !important;
}

.styled-input>>>.v-icon {
  color: #9ca3af;
}

.styled-input>>>.v-input--is-focused .v-icon {
  color: #0e81c4;
}

/* Login Button */
.login-btn {
  background: linear-gradient(135deg, #0e81c4 0%, #0a6ba3 100%) !important;
  color: white !important;
  height: 50px !important;
  border-radius: 12px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  box-shadow: 0 4px 16px rgba(14, 129, 196, 0.4) !important;
  transition: all 0.2s ease !important;
  margin-top: 8px;
}

.login-btn:hover {
  box-shadow: 0 6px 20px rgba(14, 129, 196, 0.5) !important;
  transform: translateY(-1px);
}
</style>